const API_URL = 'https://jsonplaceholder.typicode.com';

export { API_URL };